<div class="expandable-order-search">
  <button
    *ngIf="!isExpanded()"
    type="button"
    class="expandable-order-search__icon-btn"
    (click)="$event.stopPropagation(); toggleExpand()"
    aria-label="Search orders"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3-3" />
    </svg>
  </button>

  <div *ngIf="isExpanded()" class="expandable-order-search__field">
    <span class="expandable-order-search__lens" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.8">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3-3" />
      </svg>
    </span>
    <input
      #searchInput
      [type]="isNativeInput ? 'text' : 'search'"
      enterkeyhint="search"
      inputmode="search"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      [value]="value()"
      (input)="onInput($event)"
      (keydown.enter)="onEnter($event)"
      [placeholder]="displayPlaceholder()"
      class="expandable-order-search__input"
    />
    <button
      type="button"
      (click)="clear()"
      [class.invisible]="!value()"
      [attr.aria-hidden]="!value()"
      [class.pointer-events-none]="!value()"
      class="expandable-order-search__clear"
      aria-label="Clear search"
    >
      <span class="text-xl leading-none" aria-hidden="true">×</span>
    </button>
  </div>
</div>
